import DashboardLayout from "../layouts/dashboardLayout";
import PageTracker from "../layouts/PageTracker";
import AccountPage from "../pages/dashboard/account";
import AdminCompaniesPage from "../pages/dashboard/admin/companies";
import CompanyPage from "../pages/dashboard/admin/company";
import DevicesPAge from "../pages/dashboard/admin/devices";
import AdminHomePage from "../pages/dashboard/admin/home";
import UsersAnalyticsPage from "../pages/dashboard/admin/userAnalytics";
import FinancePage from "../pages/dashboard/finance";
import FinanceSitePage from "../pages/dashboard/finance/site";
import TransactionsPage from "../pages/dashboard/finance/transactions";
import ManagerHomePage from "../pages/dashboard/manager";
import OperationsPage from "../pages/dashboard/operations";
import ActivityLogPage from "../pages/dashboard/operations/activityLog";
import AggregateSiteDashboardPage from "../pages/dashboard/operations/aggregate";
import SitePage from "../pages/dashboard/operations/site";
import OperationsSitePage from "../pages/dashboard/operations/sites";
import AuthGuard from "./AuthGuard";
import UserAnalyticsDetailPage from "../pages/dashboard/admin/userAnalyticsDetail";

const dashboardRoutes = [
  {
    path: "/dashboard",
    element: (
      <AuthGuard>
        <PageTracker>
          <DashboardLayout />
        </PageTracker>
      </AuthGuard>
    ),
    children: [
      // {
      //   path: "home",
      //   element: <AdminIndexPage />,
      // },
      {
        path: "admin/home/:id",
        element: <AdminHomePage />,
      },
      {
        path: "admin/companies",
        element: <AdminCompaniesPage />,
      },
      {
        path: "admin/companies/:id",
        element: <CompanyPage />,
      },
      {
        path: "admin/user-analytics/:id",
        element: <UsersAnalyticsPage />,
      },
      {
        path: "admin/user-analytics-detail/:user_id/:id",
        element: <UserAnalyticsDetailPage />,
      },
      {
        path: "admin/devices/:id",
        element: <DevicesPAge />,
      },
      {
        path: "my-account",
        element: <AccountPage />,
      },
      {
        path: "operations/home/:id",
        element: <OperationsPage />,
      },
      // operations
      {
        path: "operations/site/:id",
        element: <SitePage />,
      },
      {
        path: "operations/sites/:id",
        element: <OperationsSitePage />,
      },
      {
        path: "operations/sites/aggregate/:id",
        element: <AggregateSiteDashboardPage />,
      },
      {
        path: "operations/activity-log/:id",
        element: <ActivityLogPage />,
      },

      // finance
      {
        path: "finance/home/:id",
        element: <FinancePage />,
      },
      {
        path: "finance/sites/:id",
        element: <OperationsSitePage />,
      },
      {
        path: "finance/site/:id",
        element: <FinanceSitePage />,
      },

      {
        path: "finance/transactions/:id",
        element: <TransactionsPage />,
      },

      // Senior Manager
      {
        path: "senior-manager/home/:id",
        element: <ManagerHomePage />,
      },
      {
        path: "senior-manager/sites/:id",
        element: <OperationsSitePage />,
      },
    ],
  },
];

export default dashboardRoutes;
// headers {'alg': 'RS256', 'typ': 'JWT', 'kid': 'GAXgzp9ZIH_E0hSprsL0v'}
